/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ng-select.ng-select-single .ng-select-container{border-color:#cbd5e0!important;box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06)!important}  .ng-select .ng-arrow-wrapper .ng-arrow{background:url(/assets/svgs/select-arrow.svg) right no-repeat!important}.ng-select[_ngcontent-%COMP%]{width:100%!important}\n/*# sourceMappingURL=payment-entry-form.component.css.map*/"];
export { styles as styles };
